import {
    List,
    Datagrid,
    TextField,
    NumberField,
    EditButton,
    Filter,
    TopToolbar,
    CreateButton,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';
import { OrganizationAutocomplete } from '../../common/inputs/autoCompleteInputs/OrganizationAutoComplete';
import { KeyValueField } from '../../common/KeyValueField';

const ListFilter = (props: any) => (
    <Filter {...props}>
        <OrganizationAutocomplete alwaysOn />
    </Filter>
);

const ListActions = ({ isAdmin }: any) => <TopToolbar>{isAdmin && <CreateButton />}</TopToolbar>;

const OrganizationResourcesList = () => {
    const user = JSON.parse(localStorage.getItem('user') as string);
    const isAdmin = user?.role === 'ADMIN';

    return (
        <List
            filters={<ListFilter />}
            actions={<ListActions isAdmin={isAdmin} />}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <Datagrid bulkActionButtons={false}>
                <TextField source="title" />
                <NumberField source="displayOrder" />

                <KeyValueField source="data" />
                <FormattedDateTimeField source="createdAt" />
                {isAdmin && (
                    <>
                        <EditButton />
                        <ConfirmDeleteButton />
                    </>
                )}
            </Datagrid>
        </List>
    );
};

export default OrganizationResourcesList;
